<section class="background-color-nearwhite filtering-section" [style.visibility]="(showFilters$ | async) ? 'visible' : 'hidden'">
    <ng-container *ngIf="!(loading$ | async)">
        <div class="container">
            <da-filtering
                #fiters
                *ngIf="categories$ | async"
                [showSecondLevelFiltering]="showSecondLevelFiltering$ | async"
                [hideFirstLevelFiltering]="hideFirstLevelFiltering$ | async"
                [showThirdLevelFiltering]="showThirdLevelFiltering$ | async"
                [categories]="categories$ | async"
                [hasCourses]="showFilter$ | async"
                (change)="onSelect($event)"
                (changeDivision)="onSelectDivision($event)"
                (changeSubCat)="onSelectSubCat($event)"
                (changeSubSubCat)="onSelectSubSubCat($event)"
                (titleValue)="titleChange($event)"
                [saveFilteringParams]="true"
                [filterName]="'common.filteringDropdownBusinessField' | translate"
                [coursesByTitle]="coursesByTitle"
                [isUserPage]="isUserPage"
                [filterResetDone]="filterResetDone"
                [parameterFromURL]="parameterFromURL"
                [hasLoggedIn]="hasLoggedIn$ | async"
            ></da-filtering>
        </div>

        <ng-container *ngIf="showFiltering$ | async">
            <div class="container toggle-filtering" [class.active]="(show$ | async)">
                <div class="reset-wrapper">
                    <div class="reset-inner" [class.active]="!(show$ | async)">
                        <span class="reset" (click)="resetFilters()"
                            ><span class="content" [innerHTML]="'courses.resetAll' | translate"></span
                        ></span>
                    </div>
                </div>
                <div class="filtering-toggle" #filtering>
                    <span class="title" *ngIf="!(show$ | async)" (click)="toggleFilters(true)"
                        ><span class="content" [innerHTML]="'courses.showMoreFIlters' | translate"></span
                    ></span>
                    <span class="title" *ngIf="(show$ | async)" (click)="toggleFilters(false)"
                        ><span class="content" [innerHTML]="'courses.closeFIlters' | translate"></span
                    ></span>
                </div>
            </div>

            <div class="container filtering toggle" [class.active]="(show$ | async)">
                <div class="checkbox-wrapper">
                    <div>
                        <div *ngIf="showFilterByProductType('SEM') || showFilterByProductType('WRK')">
                            <label for="presence" id="label-subscribe" class="checkboxlabel">
                                <input
                                    id="presence"
                                    type="checkbox"
                                    [(ngModel)]="isPresence"
                                    (change)="onSelectFilterByProductType($event.target, 'Presence')"
                                />
                                <span class="checkboxlabelvalue">{{ 'courses.presence' | translate }}</span>
                            </label>
                        </div>
                        <div *ngIf="showFilterByProductType('WBN')">
                            <label for="virtual" id="label-subscribe" class="checkboxlabel">
                                <input
                                    id="virtual"
                                    type="checkbox"
                                    [(ngModel)]="isVirtual"
                                    (change)="onSelectFilterByProductType($event.target, 'Virtual')"
                                />
                                <span class="checkboxlabelvalue">{{ 'courses.virtual' | translate }}</span>
                            </label>
                        </div>
                        <div *ngIf="showFilterByProductType('WBT')">
                            <label for="online" id="label-subscribe" class="checkboxlabel">
                                <input
                                    id="online"
                                    type="checkbox"
                                    [(ngModel)]="isOnline"
                                    (change)="onSelectFilterByProductType($event.target, 'Online')"
                                />
                                <span class="checkboxlabelvalue">{{ 'courses.online' | translate }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="select-container">
                    <ng-container *ngIf="courseFilterMonths$ | async as months">
                        <ng-container *ngIf="months && months.length > 0">
                            <!-- <da-select
                                ngDefaultControl
                                [disable]="!(months.length > 0)"
                                [title]="'courses.searchByMonth' | translate"
                                [options]="months"
                                #s="ngModel"
                                [(ngModel)]="month"
                                [variable]="'monthFiltering'"
                                (change)="onSelectFilter($event.target, 'monthFiltering')"
                            ></da-select> -->

                            <div class="select" [class.active]="hasFocusMonth" *ngIf="months">
                                <span class="labelcontent fixed" [innerHTML]="'courses.searchByMonth' | translate"></span>
                                <div class="select-wrapper" [class.disabled]="months.length <= 0">
                                    <select
                                        (focus)="hasFocusMonth = true"
                                        (blur)="hasFocusMonth = false"
                                        [disabled]="!(months.length > 0)"
                                        #s="ngModel"
                                        (change)="onSelectFilter($event.target, 'month')"
                                        [(ngModel)]="month"
                                    >
                                        <option *ngFor="let item of months" [value]="item.key">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="courseFilterYears$ | async as years">
                        <ng-container *ngIf="years && years.length > 0">
                            <!-- <da-select
                                ngDefaultControl
                                [disable]="!(years.length > 0)"
                                [title]="'courses.searchByYear' | translate"
                                [options]="years"
                                #s="ngModel"
                                [(ngModel)]="year"
                                [variable]="'yearTypeFiltering'"
                                (change)="onSelectFilter($event.target, 'yearTypeFiltering')"
                            ></da-select> -->

                            <div class="select" [class.active]="hasFocusYear" *ngIf="years">
                                <span class="labelcontent fixed" [innerHTML]="'courses.searchByYear' | translate"></span>
                                <div class="select-wrapper" [class.disabled]="years.length <= 0">
                                    <select
                                        (focus)="hasFocusYear = true"
                                        (blur)="hasFocusYear = false"
                                        [disabled]="!(years.length > 0)"
                                        #s="ngModel"
                                        (change)="onSelectFilter($event.target, 'year')"
                                        [(ngModel)]="year"
                                    >
                                        <option *ngFor="let item of years" [ngValue]="item.key">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="courseFilterCities$ | async as cities">
                        <ng-container *ngIf="cities && cities.length > 0">
                            <div class="select cities" [class.active]="hasFocusCity" *ngIf="cities">
                                <span class="labelcontent fixed" [innerHTML]="'courses.filterByCity' | translate"></span>
                                <div class="select-wrapper" [class.disabled]="cities.length <= 0">
                                    <select
                                        (focus)="hasFocusCity = true"
                                        (blur)="hasFocusCity = false"
                                        [disabled]="!(cities.length > 0)"
                                        #s="ngModel"
                                        [(ngModel)]="city"
                                        (change)="onSelectFilter($event.target, 'city')"
                                    >
                                        <option *ngFor="let item of cities" [ngValue]="item.key">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
                <div>
                    <span class="reset" (click)="resetFilters()"
                        ><span class="content" [innerHTML]="'courses.resetAll' | translate"></span
                    ></span>
                </div>
            </div>
        </ng-container>
    </ng-container>
</section>
<section *ngIf="showTextToTrainingAdvisor && site === 'de_de'" class="background-color-nearwhite link-to-training-advisor">
    <div class="container">
        <p [innerHTML]="'trainingAdvisor.textToTrainingAdvisorPage' | translate"></p>
        <a da-link href="{{linkToTrainingAdvisor}}" [innerHTML]="'trainingAdvisor.linkToTrainingAdvisorPage' | translate"></a>
    </div>
</section>
<section class="background-color-white sorting-section" [style.visibility]="(showList$ | async) ? 'visible' : 'hidden'">
    <ng-container *ngIf="!(loading$ | async)">
        <div class="sorting container">
            <div class="number-of-items">
                <strong><span [innerHTML]="'courses.coursesFound' | translate"></span> {{ numberOfCourses$ | async }}</strong>
            </div>
            <div class="sort-switch-wrapper">
                <div class="select" *ngIf="sortOptions$ | async as sortingOptions">
                    <span class="labelcontent fixed" [innerHTML]="'courses.sortBy' | translate"></span>
                    <div class="select-wrapper" [class.disabled]="sortingOptions.length <= 0">
                        <select
                            (focus)="hasFocusMonth = true"
                            (blur)="hasFocusMonth = false"
                            [disabled]="!(sortingOptions.length > 0)"
                            #s="ngModel"
                            (change)="onSelectFilter($event.target, 'selectedSortingValue')"
                            [(ngModel)]="sortValue"
                        >
                            <option *ngFor="let item of sortingOptions" [ngValue]="item.key">{{ item.value }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="coursesFiltered$ | async as coursesFiltered">
        <div class="container" *ngIf="coursesFiltered.length <= 0 && !(serverError$ | async)">
            <div class="intro" [innerHTML]="'courses.noCoursesAvailable' | translate"></div>
        </div>

        <div class="container" *ngIf="coursesFiltered && coursesFiltered.length > 0">
            <div class="courses long-view-wrapper">
                <div *ngFor="let course of coursesFiltered">
                    <da-course-item *ngIf="course" [course]="course" [allCategories]="categories$ | async" [portal]="portal" [site]="site"></da-course-item>
                </div>
            </div>
            <section [ngClass]="{ hidden: (showMoreInformation$ | async) === false }">
                <div class="courses more-courses long-view-wrapper">
                    <div *ngFor="let course of coursesFilteredMore$ | async">
                        <da-course-item *ngIf="course" [course]="course" [portal]="portal" [site]="site"></da-course-item>
                    </div>
                </div>
            </section>

            <section *ngIf="coursesFilteredMore$ | async as coursesFilteredMore">
                <da-show-more
                    #showMoreSection
                    *ngIf="coursesFilteredMore.length > 0"
                    [expand]="expand"
                    (toggle)="showMore($event)"
                    [labelMore]="'common.labelMore' | translate"
                    [labelLess]="'common.labelLess' | translate"
                    [backgroundColor]="'white'"
                ></da-show-more>
            </section>
        </div>
    </ng-container>

    <section class="background-color-darkorange error" *ngIf="showServerError$ | async">
        <div class="container">
            <span class="error-message" [innerHTML]="'courses.serverError' | translate"></span>
            <button class="drg-icon-close" (click)="closeError()"></button>
        </div>
    </section>
</section>
<section class="background-color-white" *ngIf="loading$ | async">
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</section>
